export const removePlusSignSuffix = (text: string) => {
  return String(text)?.split('+')[0];
};
